import { Result, ShowResultAlertDialog } from './base/Result';

import { Cookie } from '../utils/Cookies';

export default class UserProtocol {
  static pIns = new UserProtocol();
  static ins() { return this.pIns; }

  constructor(){
    console.log("User Protocol init.");
  }

  reqLogin (username, password, callback) { 
    fetch(`/api/login`, {
      credentials: 'include',
      method: 'POST',
      body: `username=${username}&password=${password}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => callback(res.status))
      .catch(err => console.error("Error:", err));
  };


 getDashboardInfo(){
  fetch("/api/announcement/list",{credentials: 'include'})
  .then(res => res.json())
  .then(
    (result) => {
      console.log("getDashboardInfo:::")
console.log(JSON.stringify(result))
console.log(result.resultCode)
console.log(result.data)
    },
    (error) => {
    console.log("error in dashboard:",error)
    }
  )
 };


 getReportInfo(){
  fetch("/api/system/issue/report",{credentials: 'include',method:"POST"})
  .then(res => res.json())
  .then(
    (result) => {
console.log("getReportInfo:::")      
console.log(JSON.stringify(result))
    },
    (error) => {
    console.log("error in report:",error)
    }
  )
 };

 getIssueList(){
  fetch("/api/system/issue/list",{credentials: 'include'})
  .then(res => res.json())
  .then(
    (result) => {
console.log("getIssueList")      
console.log(JSON.stringify(result))
    },
    (error) => {
    console.log("error in IssueList:",error)
    }
  )
 };



 getAccountInfo(){
  fetch("/api/account/info",{credentials: 'include'})
  .then(res => res.json())
  .then(
    (result) => {
console.log("getAccountInfo:::")      
console.log(JSON.stringify(result))
    },
    (error) => {
    console.log("error in getAccountInfo:",error)
    }
  )
 };



  reqGetUserList (groupId, callback) {
    this.onGetUserListCallback = callback;



    //for test
    let CompanyTree = [
      {
        GroupId: 1,
        GroupName: "AIV餐飲集團",
        Brand: [
          {
            BrandId: 1,
            BrandName: "中華一番鍋物",
            Store: [
              {
                StoreId: 1,
                StoreName: "信義區1號分店"
              },
              {
                StoreId: 2,
                StoreName: "信義區2號分店"
              },
              {
                StoreId: 3,
                StoreName: "南港車站分店"
              }
            ]
          },
          {
            BrandId: 2,
            BrandName: "滿漢全席中華料理",
            Store: [
              {
                StoreId: 4,
                StoreName: "台北車站微風店"
              },
              {
                StoreId: 5,
                StoreName: "南港車站分店"
              }
            ]
          }
        ]
      },
      {
        GroupId: 2,
        GroupName: "滿漢傳奇餐飲集團",
        Brand: [
          {
            BrandId: 3,
            BrandName: "菊下樓",
            Store: [
              {
                StoreId: 6,
                StoreName: "四川總店"
              },
              {
                StoreId: 7,
                StoreName: "陽泉酒家分店"
              }
            ]
          }
        ]
      }
    ];
    let UserListData = [
      ["WKT0123456789", "Kunder_Lin", "AIV餐飲集團\\中華一番鍋物\\南港車站分店", "行銷部", 3, "kunder_lin@aivalue.com.tw", 1],
      ["WKT0123456788", "elegant_chen", "AIV餐飲集團\\中華一番鍋物\\南港車站分店", "管理部", 3, "kunder_lin@aivalue.com.tw", 0],
      ["WKT0123456787", "呂嘉仁", "AIV餐飲集團\\中華一番鍋物\\南港車站分店", "人事部", 2, "kunder_lin@aivalue.com.tw", -1],
      ["WKT0123456786", "西野加奈", "AIV餐飲集團\\中華一番鍋物\\南港車站分店", "行銷部", 1, "kunder_lin@aivalue.com.tw", 1],
      ["WKT0123456785", "劉昴星", "滿漢傳奇餐飲集團\\菊下樓\\陽泉酒家分店", "研發部", 1, "kunder_lin@aivalue.com.tw", 1]
    ];
    let resp = {
      Company: CompanyTree,
      UserList: UserListData
    };
    this.onGetUserList(Result.OK, resp);
  }

  onGetUserList (rs, resp) {
    if(rs !== Result.OK){
      ShowResultAlertDialog(rs);
      return;
    }

    this.onGetUserListCallback(resp.Company, resp.UserList);
  }

  reqGetPersonalInfo (callback) {
    this.onGetPersonalInfoCallback = callback;

    //for test
    let resp = {
      UserId: 1001,
      Account: Cookie.get('LoginUser'),
      Email: Cookie.get('LoginUser'),
      UserName: '呂嘉仁',
      Phone: '0987654321',
      Role: 2,
      Organization: '智慧價值 > 研發部'
    };
    this.onGetPersonalInfo(Result.OK, resp);
  }

  onGetPersonalInfo (rs, resp) {
    if(rs !== Result.OK){
      ShowResultAlertDialog(rs);
      return;
    }

    this.onGetPersonalInfoCallback(resp);
  }
}